<!--<div class="pagebrk"></div>
  <printheaderview>
  </printheaderview>-->
<div class="pagebrk">
  <div class="row">
    <div class="col-print-12 padding-left-0px">
      <div class="card">
        <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

          <div class="row">
            <div class="col-print-12 text-align-center">
              <label class="font-familyhead">Expenses Report</label>              
            </div>
          </div>


          <div class="col-print-12 bordertop">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-12">
                <div class="table-component margin-bottom-0px">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero border4">
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                          Voucher No
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                          Created Date
                        </th>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                          Payment Mode
                        </th>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                          Employee
                        </th>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                          Purpose
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                          Total Amount
                        </th>
                        <!--<th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                          Status
                        </th>-->
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                          Approved By Name
                        </th>

                      </tr>
                      <tr *ngFor="let l of pdata">
                        <td class="font-family padding-top-2px padding-bottom-2px">{{l.VoucherNo}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px">{{l.ReceiptDate| date:'MMM-dd-yyyy'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px">{{l.PaymentInstrument}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px">{{l.EmployeeName}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px">
                          {{l.Towards}}
                        </td>
                        <td class="font-family padding-top-2px padding-bottom-2px">{{l.TotalAmount}}</td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px">Approved</td>-->
                        <td class="font-family padding-top-2px padding-bottom-2px">{{l.EmployeeName}}</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
   
        </div>
      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
